export const EMAIL_REG_EXP = /^[a-zA-Z0-9._%'+-]+@(?:[a-zA-Z0-9-]+[.])+[a-zA-Z]{2,63}$/;
